export default  {
    defaultHost: `${window.location.protocol}//${window.location.hostname}/`,
    refLinkSkeleton: `${window.location.protocol}//${window.location.hostname}/?ref=\n`,
}